
import { create_bot_fail, create_bot_set_embedding_model_list, create_bot_set_model_list, create_bot_set_start_loader, create_bot_sucess, create_set_Bot_Group_List, create_thread_fail, delete_thread_fail, delete_thread_sucsess, fetch_thread_list_failed, fetch_thread_list_start_loading, fetch_thread_list_success, Get_Website_Links, Get_Website_Map, update_db_bot_success } from "./reducer";
import { add_user_to_bot, create_bot_Combine, create_bot_Combine_logo, create_db_bot, create_new_thread, delete_Thread, fetch_website_links, fetch_website_map, get_BotListGroup, get_Embedding_Models, get_Models, get_Threads, update_combine_bot, update_db_bot } from "../../helpers/fakebackend_helper";
import { useNavigate } from "react-router-dom";
import { bot_details, GET_TABLE_DETAILS } from "../thunks";
import { close_add_db_modal, start_db_connection_modal_loading } from "../Select_DB_Modal/reducer";
import { open_success_modal } from "../Success_Modal/reducer";
import { set_no_group_Created, set_open_create_new_bot } from "../groups/reducer";






export const Bot_Create = (filterData) => async (dispatch) => {



  try {
   
   
   
    
  } catch (error) {
    
  }
};

export const Get_Create_Bot_Model_List = (filterData) => async (dispatch) => {

    try {
      let response;
      let response_2;
        dispatch(create_bot_set_start_loader())
      
   
        response = get_Models();
        response_2 = get_Embedding_Models()
      
      
        var data_2 = await response_2;
        var data = await response;

  
  
        dispatch(create_bot_set_model_list(data));
        dispatch(create_bot_set_embedding_model_list(data_2));
  
     
      
    } catch (error) {
      dispatch(create_bot_fail(error));
    }
  };

export const Get_Create_Bot_Group_List = (filterData) => async (dispatch) =>{
    try {
        let response;
          dispatch(create_bot_set_start_loader())
        
     
          response = get_BotListGroup({
            page:1,
            per_page:100
          });
        
        
          var data = await response;
    
    
          dispatch(create_set_Bot_Group_List(data.data));
    
       
        
      } catch (error) {
        dispatch(create_bot_fail(error));
      }
}


export const Create_New_Bot = (filterData , history) => async (dispatch) =>{


 
    try {
        let response;
          dispatch(create_bot_set_start_loader())

          // console.log(filterData);
          
          const data = new FormData();
        
          data.append('Group_ID',filterData.Group_ID)
          data.append('Bot_Title',filterData.title)
          data.append('Bot_Description',filterData.description)
          data.append('Model',filterData.model)
          data.append('Type',filterData.type)
          data.append('Bot_Logo',filterData.bot_logo)
          data.append('Embedding_Model',filterData.Embedding_Model)
          
          if(filterData.type === 'DBLink' ){
          data.append('Database_ID',filterData.database_id)
          data.append('Query_Model',filterData.Query_Model)
          }
          
          response = create_bot_Combine_logo(data);
        
        
          const api_response = await response;
    
    
          dispatch(create_bot_sucess(api_response));
          dispatch(set_open_create_new_bot(false));
          dispatch(set_no_group_Created(false))


          history('/Configuration')

          
        
          
    
       
        
      } catch (error) {
        dispatch(create_bot_fail(error));
      }
}


export const update_Bot_Combine= (filterData , history) => async (dispatch) =>{
  try {
      let response;
        dispatch(create_bot_set_start_loader())
      
   
        response = update_combine_bot(filterData);
      
      
        var api_response = await response;
  
       
        
        dispatch(create_bot_sucess({ data:filterData.get('Bot_ID') }));

       
         
        dispatch(bot_details(filterData.get('Bot_ID')));


        dispatch(open_success_modal("Bot knowledge Updated Successfully !"))


        // history('/Configuration')

        
      
        
  
     
      
    } catch (error) {
      dispatch(create_bot_fail(error));
    }
}


export const Update_DB_Bot = (filterData)=> async (dispatch)=>{
  try {
    let response;
      dispatch(create_bot_set_start_loader())
    
 
      response = update_db_bot(filterData);
    
    
      var api_response = await response;

      dispatch(GET_TABLE_DETAILS(filterData))
      dispatch(open_success_modal("Bot knowledge Updated Successfully !"))
      dispatch(update_db_bot_success())

      // dispatch(bot_details(filterData.assistant_id));


      // history('/Configuration')

      
    
      

   
    
  } catch (error) {
    dispatch(create_bot_fail(error));
  }
}


export const fetch_web_site_link= (filterData , history) => async (dispatch) =>{
  try {
      let response;
        dispatch(create_bot_set_start_loader())
      
         filterData['type'] = 'url'
        response = fetch_website_links(filterData);
      
      
        var api_response = await response;
  
  
        dispatch(Get_Website_Links(api_response));


        // dispatch(bot_details(filterData.assistant_id));


        // history('/Configuration')

        
      
        
  
     
      
    } catch (error) {
      dispatch(create_bot_fail(error));
    }
}


export const fetch_web_site_map= (filterData , history) => async (dispatch) =>{
  try {
      let response;
        dispatch(create_bot_set_start_loader())
      
       filterData['type'] = 'sitemap'
        response = fetch_website_map(filterData);
      
      
        var api_response = await response;
  
  
        dispatch(Get_Website_Links(api_response));


        // dispatch(bot_details(filterData.assistant_id));


        // history('/Configuration')

        
      
        
  
     
      
    } catch (error) {
      dispatch(create_bot_fail(error));
    }
}


export const Create_Bot_Database_Structure= (filterData , history) => async (dispatch) =>{
  try {
      let response;
        dispatch(start_db_connection_modal_loading())
      
   
        response = create_db_bot(filterData);
      
      
        var api_response = await response;
  
  
        dispatch(create_bot_sucess(api_response));
        dispatch(set_open_create_new_bot(false));
        dispatch(set_no_group_Created(false))
      
        

        history('/Configuration')


        
      
        
  
     
      
    } catch (error) {
      dispatch(create_bot_fail(error));
    }
}


export const fetch_selected_table = (filterData , history) => async (dispatch) =>{
  try {
      let response;
        dispatch(start_db_connection_modal_loading())
      
   
        response = create_db_bot(filterData);
      
      
        var api_response = await response;
  
  
        dispatch(create_bot_sucess(api_response));
           
      
        

        history('/Configuration')


        
      
        
  
     
      
    } catch (error) {
      dispatch(create_bot_fail(error));
    }
}






  






  

